import type { UseQueryResult } from '@tanstack/react-query'
import { ListPage } from '@/components/templates/list-page'
import { Alert } from '@/components/ui/alert'
import { EmptyState } from '@/components/ui/empty-state'
import type { CustomField, CustomFieldsResponse } from '@/lib/contacts/types'
import { CustomFieldsTable } from '@/pages/CustomFieldsTable'

export function CustomFieldsList({
  query,
  lifecycleError,
  reorderError,
  reorderPending,
  onCreate,
  onEdit,
  onReorder,
  onSetActive,
  onDelete,
}: {
  query: UseQueryResult<CustomFieldsResponse>
  lifecycleError: string | null
  reorderError: string | null
  reorderPending: boolean
  onCreate: () => void
  onEdit: (field: CustomField) => void
  onReorder: (customFields: CustomField[]) => void
  onSetActive: (field: CustomField, active: boolean) => void
  onDelete: (field: CustomField) => void
}) {
  return (
    <ListPage title="Custom fields" primaryAction={{ label: 'New field', onClick: onCreate }}>
      {query.isLoading && <EmptyState title="Loading Custom Fields" />}
      {query.isError && !query.isLoading && (
        <EmptyState title="Custom Fields unavailable" description="Refresh and try again." />
      )}
      {query.isSuccess && query.data.custom_fields.length === 0 && (
        <EmptyState title="No Custom Fields yet" />
      )}
      {lifecycleError && <Alert>{lifecycleError}</Alert>}
      {reorderError && <Alert>{reorderError}</Alert>}
      {query.isSuccess && query.data.custom_fields.length > 0 && (
        <CustomFieldsTable
          customFields={query.data.custom_fields}
          onEdit={onEdit}
          onReorder={onReorder}
          reorderPending={reorderPending}
          onSetActive={onSetActive}
          onDelete={onDelete}
        />
      )}
    </ListPage>
  )
}
